import Cookies from 'js-cookie'

const TokenKey1 = 'MToken'
const TokenKey2 = 'PToken'

export function getMToken() {
    return Cookies.get(TokenKey1)
}

export function setMToken(token) {
    return Cookies.set(TokenKey1, token)
}

export function removeMToken() {
    return Cookies.remove(TokenKey1)
}


export function getPToken() {
    return Cookies.get(TokenKey2)
}

export function setPToken(token) {
    return Cookies.set(TokenKey2, token)
}

export function removePToken() {
    return Cookies.remove(TokenKey2)
}
